// 站点支持的 8 种语言（顺序与后端 support_langs() 一致）
// 不属于这 8 种语言的国家/地区，后端统一返回 en_us
export const LANGS = [
  { code: 'en_us', name: 'English',    flag: '🇺🇸' },
  { code: 'es_spa', name: 'Español',   flag: '🇪🇸' },
  { code: 'fr',    name: 'Français',   flag: '🇫🇷' },
  { code: 'de',    name: 'Deutsch',    flag: '🇩🇪' },
  { code: 'it',    name: 'Italiano',   flag: '🇮🇹' },
  { code: 'nl',    name: 'Nederlands', flag: '🇳🇱' },
  { code: 'pt',    name: 'Português',  flag: '🇵🇹' },
  { code: 'pl',    name: 'Polski',     flag: '🇵🇱' },
];

export const SUPPORT_LANGS = LANGS.map(item => item.code);

export function langName(code) {
  const hit = LANGS.find(item => item.code === code);
  return hit ? hit.name : 'English';
}

// 是否用户手动切过语言（手动优先，不再被 IP / 注册地区覆盖）
export const LANG_MANUAL_KEY = 'lang_manual';

export function setLangManual() {
  localStorage.setItem(LANG_MANUAL_KEY, '1');
}
